import React from 'react';
import { Link } from 'react-router-dom';

const CarPolicePage: React.FC = () => (
  <div className="min-h-screen bg-gray-50">
    <div className="max-w-4xl mx-auto px-6 py-8">
      <div className="mb-6">
        <div className="grid grid-cols-3 items-center">
          <div className="justify-self-start">
            <Link to="/" className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
              <span>Zurück zum Hub</span>
            </Link>
          </div>
          <div className="justify-self-center">
            <h2 className="text-3xl font-bold text-gray-900 ">Car Policy</h2>
          </div>
          <div className="justify-self-end"></div>
        </div>
      </div>
      <div className="bg-white  rounded-lg shadow-md border border-gray-200 ">
        <div className="p-8">
          <h2 className="text-3xl font-bold mb-8 text-gray-900 ">Car Policy / Arbeitsanweisung Fuhrpark (AA-FP)</h2>
          
          {/* Document Info */}
          <div className="mb-8 bg-gray-50  rounded-lg p-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-sm">
              <div>
                <span className="font-semibold text-gray-700  block mb-1">Besitzer:</span>
                <span className="text-gray-900 ">CMO</span>
              </div>
              <div>
                <span className="font-semibold text-gray-700  block mb-1">Freigabe durch:</span>
                <span className="text-gray-900 ">Katrin Peter</span>
              </div>
              <div>
                <span className="font-semibold text-gray-700  block mb-1">Freigabe am:</span>
                <span className="text-gray-900 ">04.07.2025</span>
              </div>
              <div>
                <span className="font-semibold text-gray-700  block mb-1">Versionsstand:</span>
                <span className="text-gray-900 ">1.0.0</span>
              </div>
              <div className="md:col-span-2">
                <span className="font-semibold text-gray-700  block mb-1">Dokumenten-ID:</span>
                <span className="text-gray-900 ">AA-FP</span>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-900 ">
            <section>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 ">1. Ziel und Zweck</h3>
              <p className="leading-relaxed text-gray-900 ">
                Diese Arbeitsanweisung (im Weiteren AA-FP) beschreibt den verbindlichen Ablauf zur Auswahl, Nutzung, Pflege, Verwaltung und Rückgabe von Fahrzeugen im Fuhrpark der Unternehmen Ayedo Cloud Solutions GmbH & avemio.tech GmbH. Ziel ist es, eine standardisierte, transparente und qualitätsgesicherte Handhabung des Fuhrparks unter Einhaltung steuerlicher, datenschutzrechtlicher und betrieblicher Vorgaben sicherzustellen.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 ">2. Anwendungsbereich</h3>
              <p className="leading-relaxed text-gray-900 ">
                Dieser Prozess gilt innerhalb des Dokuments G-IMS (Geltungsbereich des integrierten Managementsystems) für den gesamten Anwendungsbereich und für alle Mitarbeitenden, denen ein Dienstfahrzeug zur Verfügung gestellt wird.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 ">3. Verantwortlichkeiten</h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-gray-200  rounded-lg overflow-hidden">
                  <thead>
                    <tr className="bg-gray-50 ">
                      <th className="p-4 text-left font-semibold text-gray-900 ">Rolle</th>
                      <th className="p-4 text-left font-semibold text-gray-900 ">Verantwortlichkeit</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 ">
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">CMO</td>
                      <td className="p-4 text-gray-900 ">Freigabe der Richtlinie und Entscheidung bei Eskalationen</td>
                    </tr>
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">CEO / CTO</td>
                      <td className="p-4 text-gray-900 ">Grundsatzentscheidungen, Budgetfreigaben</td>
                    </tr>
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">FPM (Fuhrparkmanagement)</td>
                      <td className="p-4 text-gray-900 ">Organisation, Verwaltung & Koordination des gesamten Fuhrparks, Führerscheinkontrollen, Wartungs-, Schadens- und Aus-/Rückgabemanagement, Sicherstellung gesetzlicher Vorgaben</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 ">4. Prozessbeschreibung</h3>
              
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.1 Anspruch und Zuweisung</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Anspruch ab 6 Monaten ununterbrochener Betriebszugehörigkeit.</li>
                    <li>Antragstellung bei FPM (Fuhrparkmanagement); Entscheidung durch Geschäftsleitung.</li>
                    <li>Fahrzeugpräferenzen können geäußert werden, Auswahl erfolgt nach Budget und Rahmenbedingungen.</li>
                    <li>Fahrzeuge mit umweltfreundlicher Antriebstechnologie (Hybrid oder elektrisch) werden bevorzugt, um steuerliche Vorteile und ökologische Aspekte zu nutzen.</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.2 Übergabe und Rückgabe</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Vor Übergabe wird das Fahrzeug vom Fuhrparkmanagement umfassend geprüft und ein standardisiertes Übergabeprotokoll erstellt und von FPM unterzeichnet.</li>
                    <li>Die Übergabe erfolgt in gereinigtem, technisch einwandfreiem und vollgetanktem Zustand und zur Bestätigung durch Gegenzeichnung des Übergabeprotokolls.</li>
                    <li>Rückgaben erfolgen gemäß Arbeitsanweisung Rückgabe von Firmeneigentum (AA-OFF-FE) in Verbindung mit dem Übergabeprotokoll. Die Fahrzeuge müssen gereinigt und voll einsatzbereit sein und dürfen keine technischen Mängel oder Schäden aufweisen.</li>
                    <li>Das Übergabeprotokoll ist in vier Teilschritten unterteilt und von FPM und Mitarbeitenden zwingend und vollständig zu unterzeichnen:
                      <ul className="list-disc ml-6 mt-2 space-y-1 text-gray-900 ">
                        <li>Laufleistung zum Rückgabezeitpunkt → Abschnitt Kilometerstand</li>
                        <li>Zustand Innen und Außen → Abschnitt Gesamtzustand</li>
                        <li>Auflistung des übergebenen Equipments → Abschnitt Equipment</li>
                        <li>Schäden / Mängel → Abschnitt Schadensreport</li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.3 Nutzung und Verhalten</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Branding für jedes Firmenfahrzeug ist verpflichtend. Über die Art des Brandings entscheidet FPM gemeinsam mit Team BRAND.</li>
                    <li>Für eine bestmögliche werbliche Außen­darstellung sicherzustellen, sind alle Firmenfahrzeuge regelmäßigen Außen- und Innenreinigungen, Wartungen auf Kosten des Unternehmens mit DKV-Karte zu unterziehen.</li>
                    <li>Pflicht zur unverzüglichen Meldung jedes festgestellten Schadens und jeder Änderung des Führerscheinstatus.</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.4 Regelmäßige Führerscheinkontrollen</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Arbeitgeber ist aus rechtlichen Gründen (Halterpflichten nach StVZO und zur Vermeidung von Organisationsverschulden) verpflichtet, regelmäßig den Führerscheinstatus aller Mitarbeitenden mit Dienstfahrzeug zu überprüfen und zu dokumentieren.</li>
                    <li>Die Überprüfung erfolgt mindestens halbjährlich sowie bei jeder Neuzuteilung eines Fahrzeugs durch FPM.</li>
                    <li>Die Kontrollen werden DSGVO-konform dokumentiert (Name, Datum) und nach 6 Monaten gelöscht.</li>
                    <li>Bei fehlender oder ungültiger Fahrerlaubnis wird das Fahrzeug unverzüglich entzogen und weitere arbeitsrechtliche Schritte geprüft.</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.5 Private Nutzung</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Zulässig im Rahmen der gesetzlichen Vorschriften zur Versteuerung des geldwerten Vorteilsversteuerung (0,25%-1%).</li>
                    <li>Gewerbliche und entgeltliche Nutzung ist strikt untersagt und stellt einen gravierenden Arbeitsvertragsverstoß dar.</li>
                    <li>Bei Überschreiten der vertraglich festgelegten Laufleistung durch private Nutzung trägt der Mitarbeitende die Mehrkosten anteilig mit 50%.</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.6 Verhalten bei Unfällen</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Bei allen Unfällen mit Firmenfahrzeugen sind verbindlich die Schritte gemäß „Anlage Unfallabwicklung" zu befolgen.</li>
                    <li>Es gelten die Regeln der innerbetrieblichen Arbeitnehmerhaftung:</li>
                  </ul>
                  
                  <div className="mt-4 overflow-x-auto">
                    <table className="w-full text-sm border border-gray-200  rounded-lg overflow-hidden">
                      <thead>
                        <tr className="bg-gray-50 ">
                          <th className="p-4 text-left font-semibold text-gray-900 ">Fahrlässigkeitsgrad</th>
                          <th className="p-4 text-left font-semibold text-gray-900 ">Rechtsfolge</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 ">
                        <tr className="hover:bg-gray-50 ">
                          <td className="p-4 font-medium text-gray-900 ">Leichteste Fahrlässigkeit</td>
                          <td className="p-4 text-gray-900 ">Keine Haftung des Mitarbeitenden.</td>
                        </tr>
                        <tr className="hover:bg-gray-50 ">
                          <td className="p-4 font-medium text-gray-900 ">Normale/mittlere Fahrlässigkeit</td>
                          <td className="p-4 text-gray-900 ">Haftung anteilig (Quotelung), abhängig von den Umständen.</td>
                        </tr>
                        <tr className="hover:bg-gray-50 ">
                          <td className="p-4 font-medium text-gray-900 ">Grobe Fahrlässigkeit oder Vorsatz</td>
                          <td className="p-4 text-gray-900 ">Mitarbeitende haften grundsätzlich voll.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.7 Nutzung der DKV-Karte</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Die Ausschließlich für dienstliche Zwecke (Tanken, Wäsche, Pflegeartikel).</li>
                    <li>Missbrauch führt zu Kostenübernahme und ggf. arbeitsrechtlichen Maßnahmen.</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.8 Beendigung Arbeitsverhältnis</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Fahrzeug ist unverzüglich bei Beendigung des Arbeitsverhältnisses zurückzugeben. Hierzu ist zwingend die Fahrzeugübergabe zu dokumentieren.</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold mb-3 text-gray-900 ">4.9 Schulung</h4>
                  <ul className="list-disc ml-6 space-y-2 text-gray-900 ">
                    <li>Mitarbeitende werden regelmäßig über die Inhalte der Richtlinie informiert.</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 ">5. Qualitätssicherung und Optimierung</h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-gray-200  rounded-lg overflow-hidden">
                  <thead>
                    <tr className="bg-gray-50 ">
                      <th className="p-4 text-left font-semibold text-gray-900 ">Schritt</th>
                      <th className="p-4 text-left font-semibold text-gray-900 ">Beschreibung</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 ">
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">Externe Audits</td>
                      <td className="p-4 text-gray-900 ">Jährliche Überprüfung der Unternehmensprozesse durch Zertifizierungsstelle</td>
                    </tr>
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">Interne Audits</td>
                      <td className="p-4 text-gray-900 ">Jährliche Überprüfung der Unternehmensprozesse durch QB & ISB</td>
                    </tr>
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">Gruppen-Check-Ins</td>
                      <td className="p-4 text-gray-900 ">Überprüfung der Prozesse erfolgt halbjährlich im Rahmen der Gruppen-Check-Ins durch QB</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 ">6. Dokumentation und Archivierung</h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-gray-200  rounded-lg overflow-hidden">
                  <thead>
                    <tr className="bg-gray-50 ">
                      <th className="p-4 text-left font-semibold text-gray-900 ">Schritt</th>
                      <th className="p-4 text-left font-semibold text-gray-900 ">Beschreibung</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 ">
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">Führerscheinkontrollen</td>
                      <td className="p-4 text-gray-900 ">Dokumentation von Name, Datum der Kontrolle, Löschung nach 6 Monaten</td>
                    </tr>
                    <tr className="hover:bg-gray-50 ">
                      <td className="p-4 font-medium text-gray-900 ">Rückgabeprotokolle</td>
                      <td className="p-4 text-gray-900 ">Archivierung der Rückgabeprotokolle im Fuhrparkmanagementsystem</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-gray-200 ">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Dokumente: Anlage Unfallabwicklung, Anlage FAHRZEUGÜBERGABE
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CarPolicePage; 